import React from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";

import { UIButton } from "../../../components/ui";
import messages from "../../../assets/locale/messages";
import { ROUTE_PATHS } from "../../../utils/RoutesPaths";
import { EmailIcon } from "../../../utils/Icons/EmailIcon";

const ResetPasswordSuccess = () => {
  const lang = useSelector((state) => state.locale.lang);
  const history = useHistory();
  const { pathname, state: locationState } = useLocation();
  const { forgetPassword } = messages[lang];
  const { resetSuccess } = forgetPassword;
  const ContinueIcon = lang === "ar" ? ArrowLeft : ArrowRight;

  const handleContinue = () => {
    const email =
      typeof locationState?.email === "string"
        ? locationState.email.trim()
        : "";
    const emailState = email ? { email } : {};

    if (pathname === ROUTE_PATHS.clientResetPasswordSuccess) {
      history.push(ROUTE_PATHS.clientResetPassword, emailState);
      return;
    }
    if (pathname === ROUTE_PATHS.companyResetPasswordSuccess) {
      history.push(ROUTE_PATHS.companyResetPassword, emailState);
      return;
    }
    history.push(ROUTE_PATHS.login);
  };

  return (
    <div className="auth-form-shell reset-password-success w-100">
      <div className="auth-form-shell__hero">
        <div className="auth-form-shell__icon-wrap" aria-hidden>
          <EmailIcon className="auth-form-shell__icon" />
        </div>
        <div className="auth-form-shell__text-block">
          <h1 className="auth-layout__card__title">{resetSuccess.title}</h1>
          <p className="auth-layout__card__subtitle">{resetSuccess.description}</p>
        </div>
        <UIButton
          type="button"
          variant="primary"
          size="large"
          fullWidth
          className="auth-form-shell__actions"
          endIcon={<ContinueIcon size={20} aria-hidden />}
          onClick={handleContinue}
        >
          {resetSuccess.button}
        </UIButton>
      </div>
    </div>
  );
};

export default ResetPasswordSuccess;
